const ARCHIVE_SELECTOR = 'main.product-archive';
const FILTERS_SELECTOR = `${ARCHIVE_SELECTOR} .wc-block-product-filters`;
const SECTION_SELECTOR = [
  '.wp-block-woocommerce-product-filter-attribute',
  '.wp-block-woocommerce-product-filter-taxonomy',
  '.wp-block-woocommerce-product-filter-status',
  '.wp-block-woocommerce-product-filter-rating',
].join(', ');
const HEADING_SELECTOR = '.wp-block-heading';
const PANEL_SELECTOR = '.wc-block-product-filter-checkbox-list';

function initFilterSection(section) {
  const heading = section.querySelector(HEADING_SELECTOR);
  const panel = section.querySelector(PANEL_SELECTOR);

  if (!heading || !panel || heading.dataset.filterToggleBound) {
    return;
  }

  heading.dataset.filterToggleBound = 'true';
  heading.classList.add('product-archive-filter__toggle');
  heading.setAttribute('role', 'button');
  heading.setAttribute('tabindex', '0');
  heading.setAttribute('aria-controls', panel.id || '');
  heading.setAttribute('aria-expanded', section.classList.contains('is-collapsed') ? 'false' : 'true');

  if (!panel.id) {
    panel.id = `product-filter-panel-${Math.random().toString(36).slice(2, 9)}`;
    heading.setAttribute('aria-controls', panel.id);
  }

  const toggle = () => {
    const collapsed = section.classList.toggle('is-collapsed');
    heading.setAttribute('aria-expanded', String(!collapsed));
  };

  heading.addEventListener('click', (event) => {
    if (event.target.closest('.product-archive-filters__clear')) {
      return;
    }

    toggle();
  });

  heading.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggle();
    }
  });
}

function initAllFilterSections(root = document) {
  root.querySelectorAll(SECTION_SELECTOR).forEach(initFilterSection);
}

function observeFilterUpdates() {
  const archive = document.querySelector(ARCHIVE_SELECTOR);

  if (!archive || archive.dataset.filtersObserverBound) {
    return;
  }

  archive.dataset.filtersObserverBound = 'true';

  const observer = new MutationObserver(() => {
    const filters = document.querySelector(FILTERS_SELECTOR);

    if (filters) {
      initAllFilterSections(filters);
    }
  });

  observer.observe(archive, { childList: true, subtree: true });
}

function initProductArchiveFilters() {
  if (!document.querySelector(FILTERS_SELECTOR)) {
    return;
  }

  initAllFilterSections();
  observeFilterUpdates();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductArchiveFilters);
} else {
  initProductArchiveFilters();
}
